import { TabRoute } from '../../../store';
import { CapitalGainsAndLossesContainer } from './capitalgainslosses/container';
import { CashAccountsStateContainer } from './cashAccounts/container';
import { ClientDashboardContainer } from './dashboard/container';
import { DetailsContainer } from './details/container';
import { PerformanceContainer } from './performance/container';
import { PortfolioContainer } from './portfolio/container';
import { ReportsV2Container } from './reportsV2/container';
import { TransactionsStateContainer } from './transactions/container';

export const getClientTabRoutes = (): TabRoute[] => [
  {
    label: 'DASHBOARD',
    order: 0,
    path: '/dashboard',
    component: ClientDashboardContainer,
    visible: (): boolean => true,
  },
  {
    label: 'PORTFOLIO',
    order: 1,
    path: '/portfolio',
    component: PortfolioContainer,
    visible: (): boolean => true,
  },
  {
    label: 'PERFORMANCE',
    order: 2,
    path: '/performance',
    component: PerformanceContainer,
    visible: (): boolean => true,
  },
  {
    label: 'CAPITAL GAINS & LOSSES',
    order: 4,
    path: '/capitalgainslosses',
    component: CapitalGainsAndLossesContainer,
    visible: (): boolean => true,
  },
  {
    label: 'TRANSACTIONS',
    order: 5,
    path: '/transactions',
    component: TransactionsStateContainer,
    visible: (): boolean => true,
  },
  {
    label: 'CASH ACCOUNTS',
    order: 6,
    path: '/cashaccount',
    component: CashAccountsStateContainer,
    visible: (): boolean => true,
  },
  {
    label: 'DETAILS',
    order: 7,
    path: '/details',
    component: DetailsContainer,
    visible: (): boolean => true,
  },
  {
    label: 'REPORTS',
    order: 8,
    path: '/reports',
    component: ReportsV2Container,
    visible: (): boolean => true,
  },
];
